module.exports = __webpack_public_path__ + "img/Liechtenstein.9509b991.svg";